<template>
  <div class="list_index">
      <el-table stripe border :data="tableData" :row-style="{height: '0'}" :cell-style="{padding: '10px'}">
          <el-table-column label="反馈类型" prop="feedbackType" align="center"></el-table-column>
          <el-table-column label="反馈内容" prop="feedbackContent" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="相关截图" prop="alarm_value" align="center">
            <template slot-scope="scope">
              <el-image class="image" v-for="(item,index) in scope.row.list" :key="index" :src="item" :preview-src-list="scope.row.list"></el-image>
            </template>
          </el-table-column>
          <el-table-column label="时间" prop="creationTime" align="center"></el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            :current-page="page"
            :page-size="size"
            :total="count"
            @current-change="changePage"
          ></el-pagination>
        </div>
  </div>
</template>

<script>
import DataService from '@/api/data';
export default {
  data(){
    return{
      page:1,
      size:10,
      count:0,
      tableData:[]
    }
  },
  methods:{
    Feedback(){
      DataService.Feedback({
        page:this.page,
        size:this.size
      }).then(res=>{
        this.tableData = res.data.projectSiteList;
        this.count = res.data.count;
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    changePage(page) {
      this.page = page;
      this.Feedback()
    },
  },
  mounted(){
    this.Feedback()
  }
}
</script>

<style scoped>
.image{
  width: 40px;
  height: 40px;
}
</style>